import Vue from 'vue';
import ABaseComponent from 'Components/Base/ABaseComponent';
import Component from 'vue-class-component';
import { Watch, Prop } from 'vue-property-decorator';
import { IInvoiceViewModel } from 'Api/CoreApi';
import ApiProvider from 'Api/ApiProvider';

@Component({})
export default class InvoicesComponent extends ABaseComponent {

    invoices: IInvoiceViewModel[] = [];

    search: string = '';
    from: Date = undefined;
    to : Date = undefined;

    searchTimeout: number = 0;

    @Prop({default: 'LANG1'})
    languageId: string;

    get locations() {
        let result: { [customerName: string]: IInvoiceViewModel[] } = {};
        if (this.invoices) {
            this.invoices.forEach(item => {
                let key = item.invoice.extraInfo['SellToCustomerName'];

                let invoices = result[key];
                if (!invoices) {
                    result[key] = invoices = [];
                }
                invoices.push(item);
            });
        }
        return result;
    }

    @Watch('search')
    async onSearchChanged() {
        clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(() => {
            this.load();
        },500);
    }

    async created() {
        await this.load();
    }

    async load() {
        this.setLoading();
        try {
            let client = ApiProvider.getApiClient();
            let invoicesResult = await client.getInvoices(this.search, this.from, this.to, this.languageId);
            this.invoices = invoicesResult.invoices;
            this.setLoaded();
        } catch (e) {
            this.setError(e);
        }
    }

}

Vue.component('invoices', InvoicesComponent);
